import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import { save } from "../../../../features/save/saveSlice"; 
import { walletsRoleData } from "../../../../data";
import { fetchUserMainScreen } from "../../../../features/dropdown/dropdownSlice";
 
const { TextArea } = Input;

const WalletUserModal = ({ open, handleCancel, prodd ,handleFetch}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { saving } = useSelector((state) => state.save);
  const { ndovuWallet,userMainScreen,loading } = useSelector((state) => state.dropdown);
 
  const handleUserChange = (selectedUserId) => {
    const selectedUser = userMainScreen?.find(user => user?.usrId === selectedUserId); 
    if (selectedUser) {
      form.setFieldsValue({
        wuEmail: selectedUser.usrEmail, 
        wuMobileNumber: selectedUser.usrMobileNumber 
        ? selectedUser.usrMobileNumber 
        : '254',    
      });
    }
  };

  const onFinish = async (data) => {  
    data.wuId = prodd?.wuId ?? null;
    const res = await dispatch(
      save({
        ...data,
        url: "py/saveWalletUser.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleCancel();
      await form.resetFields();
      await handleFetch()
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };
 
  async function fetchUserMainScreenData() {
    dispatch(
      fetchUserMainScreen()
    );
  }
 

  useEffect(() => {
    if (prodd) {
      form.setFieldsValue(prodd);
    } else {
      form.setFieldsValue({});
    }
  }, [prodd, form]);

 
  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={`${prodd?.wuUsrId ? "Edit Wallet User" : "Add Wallet User"}`}
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
        maskClosable={false}
        initialValues={prodd}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
          initialValues={prodd}
        >
            <Form.Item
           name="wuUsrId"
              className=""
              label={<span>Select User</span>}
              rules={[
                {
                  required: true,
                  message: "Please select user",
                },
              ]}
            >
              <Select 
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  userMainScreen?.length > 0 &&
                  userMainScreen?.map((item) => ({
                    value: item?.usrId,
                    label: item?.usrFirstName + ' ' + item?.usrLastName,
                  }))
                } 
                onChange={handleUserChange} 
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => { 
                  fetchUserMainScreenData()
                }} 
                dropdownRender={(menu) => (
                  <>
                    {loading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>

          <Form.Item
            className="table-form-item"
            name="wuMobileNumber"
            label="Mobile Number"
            rules={[
              {
                required: true,
                message: "Please add Mobile Number",
              },
              {
                validator: (_, value) => {
                  if (value && value.length === 12) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Phone number must be exactly 10 characters")
                  );
                },
              },
            ]}
          >
            <PhoneInput
              country="ke"
              countryCodeEditable={false}
              className="input"
            />
          </Form.Item>
          <Form.Item
            className="table-form-item"
            name="wuEmail"
            label="Email Address"
            rules={[
              {
                required: true,
                message: "Please add email address",
              },
              {
                type: "email",
                message: "Please enter a valid email address",
              },
            ]}
          >
            <Input type="email" className="input" />
          </Form.Item>

          <Form.Item
           name="wuUserType"
              className=""
              label={<span>Role</span>}
              rules={[
                {
                  required: true,
                  message: "Please select role",
                },
              ]}
            >
              <Select 
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  walletsRoleData?.length > 0 &&
                  walletsRoleData?.map((item) => ({
                    value: item?.value,
                    label: item?.label,
                  }))
                } 
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => { 
                }} 
              />
            </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default WalletUserModal;
